export default "__VITE_ASSET__DYWLJdMi__"